export enum ValidationBlockAction {
    RepeatPreviousBlock = 'repeat-previous-block',
    Continue = 'continue',
    InputVariable = 'input-variable',
    SendMessage = 'send-message',
    RestartFlow = 'restart-flow',
    RedirectFlow = 'redirect-flow'
}